import { request } from '@/shared/api/request'

export const save = (data, isSend, isEmployee = false) => {
	return request({ url: `/colcontract/ecd/save?isSend=${isSend}&isEmployee=${isEmployee}`, method: 'POST', data: data })
}
